import React, { createContext, useContext, useState } from "react";

interface SidebarContextValue {
  isExpanded:    boolean;
  setIsExpanded: (v: boolean) => void;
}

const SidebarContext = createContext<SidebarContextValue>({
  isExpanded:    false,
  setIsExpanded: () => {},
});

export const SidebarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <SidebarContext.Provider value={{ isExpanded, setIsExpanded }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
